import React, { FC } from "react";
import { useTranslation } from "i18n";
import { ReactComponent as InfoIconSvg } from "component-library/src/images/svg/icons/warning-icon-base.svg";
import getLongDate from "helpers/getLongDate";
import { MY_SUBSCRIPTION_FULL_PATH } from "config/common";
import { REINSTATE_SEARCH_PARAM } from "../../constants/constants";
import NotificationBanner from "../NotificationBanner";

interface Props {
  currentTermEndsAt?: string;
}

const ReinstateSubscriptionBanner: FC<Props> = ({ currentTermEndsAt = "" }) => {
  const { t } = useTranslation();

  return (
    <NotificationBanner
      messageHtml={t("common:banner.reinstate.messageHtml", {
        date: getLongDate(currentTermEndsAt),
      })}
      buttons={[
        {
          title: t("common:button.label.reinstate"),
          text: t("common:button.label.reinstate"),
          href: `${MY_SUBSCRIPTION_FULL_PATH}?${REINSTATE_SEARCH_PARAM}=true`,
          className: "bg-red-cardinal border-red-cardinal",
        },
      ]}
      icon={
        <InfoIconSvg
          width={24}
          height={24}
          className="mr-2 text-red-cardinal"
        />
      }
    />
  );
};

export default ReinstateSubscriptionBanner;
